import { Button, Modal } from 'antd';
import './enable-biometric-auth-modal.scss';
import { ModalItemProps } from 'common/components/modal/modal-context/modal-context';
import secureService from 'features/eiq-connect/service/security-service/security.service';
import { notification } from 'common/utils/notification';
import residentsService from 'common/services/residents-service/residents.service';
import userAuthStore from 'common/stores/user-auth/user-auth.store';
import eiqConnectStore from 'features/eiq-connect/store/eiq-connect.store';
import { IS_BIOMETRIC_AUTH_ENABLED } from 'common/stores/user-auth/user-auth.constants';
import { ReactComponent as FaceId } from 'assets/icons/eiq-connect/faceid.svg';

export const EnableBiometricAuthModal = ({ isOpened, handleCloseModal }: ModalItemProps) => {
  const onYesClicked = async () => {
    const creds = await secureService.generateAndStoreKeyPair();

    if (!creds) {
      notification.error({ message: 'Some error occurred', duration: 5 });
      return;
    }

    await residentsService.registerCredential(userAuthStore.webGuestResidentId!, creds);

    const value = {
      login: eiqConnectStore.residentDetails!.email,
      isEnabled: true,
    };

    localStorage.setItem(IS_BIOMETRIC_AUTH_ENABLED, JSON.stringify(value));

    notification.success({ message: 'Login with FaceID enabled', duration: 5 });

    handleCloseModal();
  };

  const onNoClicked = () => {
    handleCloseModal();
  };

  return (
    <div>
      <Modal open={isOpened} footer={null} centered closable={false} wrapClassName="enable-biometric-auth-modal">
        <div className="ant-modal-body-form-container">
          <div>
            <h1>Enable FaceID?</h1>
          </div>
          <div className="face-id-icon-wrapper">
            <FaceId width={48} />
          </div>
          <div className="ant-modal-body-form-container-text">
            Would you like to enable Face ID for faster, secure logins to EIQ-Connect?
          </div>
        </div>
        <div className="modal-footer">
          <Button onClick={onNoClicked} className="cancel-btn">
            No
          </Button>
          <Button type="primary" className="primary-btn" onClick={onYesClicked}>
            Yes
          </Button>
        </div>
      </Modal>
    </div>
  );
};
